<app-not-authorized-notice [hasOne]="['issueFlexCodes', 'issueFlexCodesView']"></app-not-authorized-notice>

<app-data-set
	#dataSet
	[rowId]="rowId"
	defaultPresentationMode="table"
	[appHasSystemCapability]
	[hasOne]="['issueFlexCodes', 'issueFlexCodesView']"
	firstColumnProperty="firstName"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="assignedTo"
				[defaultFilterLabel]="filterLabels.assignedTo"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					@if (isHaspCodeGenFeatureEnabled) {
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.codeType }}</mat-label>
								<mat-select
									data-automation-id="code-type-picker"
									[value]="dataSet.filter('codeTypeId')"
									(selectionChange)="dataSet.filter('codeTypeId', filterLabels.codeType, $event.value, codeTypeIds)"
								>
									<mat-option value="1" data-automation-id="code-type-access">
										<div class="flex-row-center-div">
											<div>
												<mat-icon
													class="capabilities-icon"
													svgIcon="sl-access-code-gen"
													matTooltip="{{ accessCodeTooltip }}"
												>
												</mat-icon>
											</div>
											<div>Access</div>
										</div>
									</mat-option>
									<mat-option value="2" data-automation-id="code-type-hasp">
										<div class="flex-row-center-div">
											<div>
												<mat-icon
													class="capabilities-icon"
													svgIcon="sl-hasp-code-gen"
													matTooltip="{{ haspCodeTooltip }}"
												>
												</mat-icon>
											</div>
											<div>Hasp</div>
										</div>
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					}

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.dateGenerated }}</mat-label>
							<input
								matInput
								[matDatepicker]="dateGeneratedPicker"
								disabled
								[ngModel]="dataSet.filter('dateGenerated')"
								(ngModelChange)="dataSet.filter('dateGenerated', filterLabels.dateGenerated, $event)"
								data-automation-id="date-generated-input"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="dateGeneratedPicker"
								data-automation-id="date-generated-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker
								#dateGeneratedPicker
								disabled="false"
								data-automation-id="date-generated-datepicker"
							></mat-datepicker>
						</mat-form-field>
					</div>

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.generatedBy }}</mat-label>
							<input
								matInput
								data-automation-id="generated-by-input"
								[ngModel]="dataSet.filter('generatedBy')"
								(ngModelChange)="dataSet.filter('generatedBy', filterLabels.generatedBy, $event)"
							/>
						</mat-form-field>
					</div>

					@if (!isHaspCodeGenFeatureEnabled) {
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.assignedTo }}</mat-label>
								<input
									matInput
									data-automation-id="assigned-to-input"
									[ngModel]="dataSet.filter('assignedTo')"
									(ngModelChange)="dataSet.filter('assignedTo', filterLabels.assignedTo, $event)"
								/>
							</mat-form-field>
						</div>
					}
				</div>
				<div class="filter-grid" [style.--columns]="isHaspCodeGenFeatureEnabled ? 3 : 2">
					@if (isHaspCodeGenFeatureEnabled) {
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.assignedTo }}</mat-label>
								<input
									matInput
									data-automation-id="assigned-to-input"
									[ngModel]="dataSet.filter('assignedTo')"
									(ngModelChange)="dataSet.filter('assignedTo', filterLabels.assignedTo, $event)"
								/>
							</mat-form-field>
						</div>
					}

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.dateValid }}</mat-label>
							<input
								matInput
								[matDatepicker]="dateValidPicker"
								disabled
								[ngModel]="dataSet.filter('dateValid')"
								data-automation-id="date-valid-input"
								(ngModelChange)="dataSet.filter('dateValid', filterLabels.dateValid, $event)"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="dateValidPicker"
								data-automation-id="date-valid-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker
								#dateValidPicker
								disabled="false"
								data-automation-id="date-valid-datepicker"
							></mat-datepicker>
						</mat-form-field>
					</div>

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.reason }}</mat-label>
							<input
								matInput
								data-automation-id="reason-input"
								[ngModel]="dataSet.filter('reason')"
								(ngModelChange)="dataSet.filter('reason', filterLabels.reason, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (canIssueFlexCodes) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Generate New Code"
					i18n-label="@@deviceGenerateCode-generateNewCodeLabel"
					(click)="onGenerateCodeClick()"
					data-automation-id="generate-new-code-button"
					[isDisabled]="!this.allowCodeGeneration || !this.deviceId || !this.device"
				></app-data-set-action-button>
			</div>
		}

		<div *appActionGroup>
			<app-data-set-action-button
				label="Download Report"
				(click)="onDownloadClicked()"
				data-automation-id="download-report-button"
				i18n-label="@@deviceGenerateCode-downloadReport"
			></app-data-set-action-button>
		</div>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getAccessCodeLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getAccessCodeLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				@if (isHaspCodeGenFeatureEnabled) {
					<ng-container matColumnDef="codeTypeId">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-codeType">Type</th>
						<td mat-cell *matCellDef="let row">
							<div class="flex-row-center-div">
								<mat-icon
									class="capabilities-icon"
									svgIcon="{{ row.codeTypeId === ACCESS_CODE_TYPE ? 'sl-access-code-gen' : 'sl-hasp-code-gen' }}"
									matTooltip="{{ row.codeTypeId === ACCESS_CODE_TYPE ? 'Access Code' : 'Hasp Code' }}"
								>
								</mat-icon>
							</div>
						</td>
					</ng-container>
				}

				<ng-container matColumnDef="dateGenerated">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-dateGenerated">
						Date Generated
					</th>
					<td mat-cell *matCellDef="let row">
						{{
							(row.utcCreateDate
								| date
									: 'mediumDate'
									: timeZoneService.utcOffset(row.utcCreateDate, row.locationTimezoneName)
									: localeService.getLocale()) +
								', ' +
								(row.utcCreateDate
									| date
										: 'shortTime'
										: timeZoneService.utcOffset(row.utcCreateDate, row.locationTimezoneName)
										: localeService.getLocale())
						}}
					</td>
				</ng-container>
				<ng-container matColumnDef="generatedBy">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-generatedBy">Generated By</th>
					<td mat-cell *matCellDef="let row">{{ row.creator.firstName }} {{ row.creator.lastName }}</td>
				</ng-container>
				<ng-container matColumnDef="assignedTo">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-assignedTo">Assigned To</th>
					<td mat-cell *matCellDef="let row">
						<span>{{ row.firstName }} {{ row.lastName }}</span>
						@if (row.email) {
							<span>, {{ row.email }}</span>
						}
						@if (row.mobilePhoneNumber) {
							<span>, {{ row.mobilePhoneNumber | autoFormatPhoneNumber }}</span>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="dateValid">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-dateStart">Date Start</th>
					<td mat-cell *matCellDef="let row">
						@if (row.codeType === 'OneDayCode') {
							{{ row.utcValidDate | accessDate }} {{ ', 12:00 AM' }}
						}
						@if (row.codeType === 'FlexCode') {
							{{
								(row.utcStartTime
									| date
										: 'mediumDate'
										: timeZoneService.utcOffset(row.utcStartTime, row.locationTimezoneName)
										: localeService.getLocale()) +
									', ' +
									(row.utcStartTime
										| date
											: 'shortTime'
											: timeZoneService.utcOffset(row.utcStartTime, row.locationTimezoneName)
											: localeService.getLocale())
							}}
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="dateEnd">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-dateEnd">Date End</th>
					<td mat-cell *matCellDef="let row">
						@if (row.codeType === 'OneDayCode') {
							- - -
						}
						@if (row.codeType === 'FlexCode') {
							{{
								(row.utcEndTime
									| date
										: 'mediumDate'
										: timeZoneService.utcOffset(row.utcEndTime, row.locationTimezoneName)
										: localeService.getLocale()) +
									', ' +
									(row.utcEndTime
										| date
											: 'shortTime'
											: timeZoneService.utcOffset(row.utcEndTime, row.locationTimezoneName)
											: localeService.getLocale())
							}}
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="reason">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-reason">Reason</th>
					<td mat-cell *matCellDef="let row">
						<span [title]="row.reason">{{ this.getShortenedText(row.reason, 50) }}</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row"></td>
				</ng-container>

				<ng-container matColumnDef="accessCode">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceOneDayCode-code">Code</th>
					<td mat-cell *matCellDef="let row">
						<span [title]="row.accessCode">{{ this.formatCodeIfNeeded(row.accessCode, row.codeTypeId) }}</span>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
